import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { OpeningHoursPickerBaseComponent } from '@luggagehero/features/shop-manager';

@Component({
  selector: 'lh-opening-hours-picker',
  templateUrl: 'opening-hours-picker.component.html',
  styleUrls: ['opening-hours-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OpeningHoursPickerComponent extends OpeningHoursPickerBaseComponent {
  constructor(cd: ChangeDetectorRef) {
    super(cd);
  }
}
